import React from "react";
import PropTypes from "prop-types";
//icons:
import { Icon } from "react-icons-kit";
import { squareO } from "react-icons-kit/fa/squareO";
import { checkSquareO } from "react-icons-kit/fa/checkSquareO";

const CheckBox = ({ className, style, title, checked = false, disabled = false, onToggle }) => {
	const onChange = (e) => {
		if (e) e.stopPropagation();
		if (disabled) return;
		if (typeof onToggle === "function") onToggle();
	};
	return (
		<button
			style={style ?? {}}
			onClick={(e) => onChange(e)}
			className={`btnDefault checkBox ${className ? className : ""} ${disabled ? "disabled" : ""}  ${checked ? "checked" : "unchecked"} pointer`}
		>
			{title && <label>{title}</label>}
			<Icon icon={checked ? checkSquareO : squareO} />
		</button>
	);
};
CheckBox.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	onToggle: PropTypes.func,
	style: PropTypes.object,
};
export default CheckBox;
